import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { branches } from "../../core/schemas/public";

// ============================================================================
// vehicle_yards — ลานจอดรถ / สถานที่จัดเก็บ
// ============================================================================
export const vehicleYards = sqliteTable("fleet_vehicle_yards", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id").references(() => branches.id),
  code: text("code").notNull(),
  name: text("name").notNull(),
  nameTh: text("name_th"),
  address: text("address"),
  capacity: integer("capacity"),
  contactPerson: text("contact_person"),
  contactPhone: text("contact_phone"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  notes: text("notes"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type VehicleYard = typeof vehicleYards.$inferSelect;
export type NewVehicleYard = typeof vehicleYards.$inferInsert;
